"use client";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";

interface CounterProps {
  value: string;
}

export function Counter({ value }: CounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const prevValue = useRef(value);

  useEffect(() => {
    if (!ref.current || prevValue.current === value) return;
    prevValue.current = value;

    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduced) return;

    gsap.fromTo(
      ref.current,
      { y: -12, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.4, ease: "power2.out" }
    );
  }, [value]);

  return (
    <span
      ref={ref}
      className="min-w-[2ch] text-center text-[clamp(28px,4vw,44px)] font-extrabold tracking-wide text-paper/25 will-change-transform"
      style={{ WebkitTextStroke: "1px rgba(246,243,236,0.5)" }}
    >
      {value}
    </span>
  );
}